// Third Party
import {
  ApolloClient,
  createHttpLink,
  DefaultOptions,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

// Utils
import getConfig from '@config';

type IsomorphicApolloClient = ApolloClient<NormalizedCacheObject>;

export function createApolloClient(
  accessToken?: string
): IsomorphicApolloClient {
  const config = getConfig();

  if (!config.serverRuntimeConfig.graphqlURL) {
    throw new Error('GraphQL URL is not defined');
  }

  const graphqlURL = config.serverRuntimeConfig.graphqlURL.toString();

  const link = createHttpLink({
    uri: graphqlURL,
  });

  const defaultOptions: DefaultOptions = {
    // watchQuery: {
    //   fetchPolicy: 'no-cache',
    //   errorPolicy: 'ignore',
    // },
    // query: {
    //   fetchPolicy: 'no-cache',
    //   errorPolicy: 'all',
    // },
  };

  const authLink = setContext((_, { headers }) => {
    return {
      headers: {
        ...headers,
        Authorization: accessToken ? `Bearer ${accessToken}` : '',
        'User-Agent': `bnbfinder-web/dev`,
      },
    };
  });

  return new ApolloClient({
    ssrMode: true,
    cache: new InMemoryCache(),
    link: authLink.concat(link),
    defaultOptions: defaultOptions,
  });
}
